// Collection-card daily offer (<lm-collection-offer>, rendered hidden by snippets/lm-collection-verified-offer.liquid).
// Shown only inside its verified window and only while every rendered field still agrees; otherwise it stays hidden.
// Re-checked at expiry, on pageshow (bfcache) and on visibilitychange. No network, storage or markup injection.
(() => {
  if (!window.customElements || customElements.get('lm-collection-offer')) return;
  const DAY = 86400000;
  const CLOCK_SKEW = 120000; // A device clock this far behind the server render time is treated as invalid.

  class CollectionOffer extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const signal = this.events.signal;
      window.addEventListener('pageshow', () => this.refresh(), { signal });
      document.addEventListener('visibilitychange', () => this.refresh(), { signal });
      this.refresh();
    }

    disconnectedCallback() {
      clearTimeout(this.expiry);
      this.events?.abort();
    }

    valid(now) {
      const data = this.dataset;
      const start = Number(data.offerStart) * 1000;
      const end = Number(data.offerEnd) * 1000;
      const rendered = Number(data.offerRendered) * 1000;
      if (data.offerState !== 'ACTIVE' || ![now, start, end, rendered].every(Number.isFinite)) return false;
      if (start <= 0 || end <= start || end - start > DAY || now < start || now >= end || now < rendered - CLOCK_SKEW) return false;
      const active = window.Shopify?.currency?.active;
      if (!/^[A-Z]{3}$/.test(data.offerCurrency || '') || (active && active !== data.offerCurrency)) return false;
      const variant = data.offerVariant || '';
      if (!/^\d+$/.test(data.offerProduct || '') || !/^\d+$/.test(variant)) return false;
      const card = this.closest('[data-product-id]');
      if (card && card.dataset.productId !== data.offerProduct) return false;
      const link = this.querySelector('a[href]');
      if (!link) return false;
      try {
        const url = new URL(link.getAttribute('href'), location.href);
        return url.origin === location.origin && /\/products\/[^/]+$/.test(url.pathname) && url.searchParams.get('variant') === variant && [...url.searchParams.keys()].length === 1;
      } catch (_) {
        return false;
      }
    }

    refresh() {
      clearTimeout(this.expiry);
      const now = Date.now();
      const valid = this.valid(now);
      this.hidden = !valid;
      if (valid) this.expiry = setTimeout(() => this.refresh(), Math.min(Number(this.dataset.offerEnd) * 1000 - now + 25, 2147483647));
    }
  }

  customElements.define('lm-collection-offer', CollectionOffer);
})();
